<template>
  <transition name="pa-simple-fade" @before-enter="handleBeforeEnter" @after-enter="handleAfterEnter">
    <div class="pa-message-app-message-view" ref="messageView" v-show="isVisible">
      <div class="message-list" ref="messageList">
        <MessageSet
          v-for="messageView in messageViewList"
          :key="messageView.id"
          :messageId="messageView.messageId"
          :isDisabled="messageView.isDisabled"

          @handleAdditionalSubmit="handleAdditionalSubmit"
          @handleAdditionalCancel="handleAdditionalCancel"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import MessageSet from '@/components/Pages/Office/MessageApp/MessageSet.vue'

export default {
  props : {
    isVisible : {
      default: false
    },

    paddingBottom : {
      default: 0
    },
  },
  
  components : {
    MessageSet
  },

  computed : {
    messageViewList(){
      return this.$store.state.message.viewList;
    },

    mainContentHeight(){
      return this.$store.state.layouts.mainContentHeight;
    },
  },

  watch : {
    paddingBottom : {
      handler(){
        this.setViewHeight();
      },
      immediate: true
    },

    mainContentHeight : {
      handler(){
        this.setViewHeight();
      },
      immediate: true
    }
  },

  methods : {
    scrollToBottom(){
      if(typeof this.$refs.messageView === 'undefined') return;
      if(typeof this.$refs.messageList === 'undefined') return;

      this.$refs.messageView.scroll(0, this.$refs.messageList.offsetHeight);
    },

    setViewHeight(){
      if(typeof this.mainContentHeight === 'undefined') return;
      if(typeof this.paddingBottom === 'undefined') return;

      const viewHeight = this.mainContentHeight - this.paddingBottom;
      
      this.$nextTick(() => {
        this.$refs.messageView.style.height = viewHeight+'px';
      });
    },

    handleBeforeEnter(){
      this.$nextTick(() => {
        this.setViewHeight();
        this.scrollToBottom();
      });
    },

    handleAfterEnter(){
      this.$emit('onVisibled');
    },

    handleAdditionalSubmit(payload){
      this.$emit('handleAdditionalSubmit', payload);
    },

    handleAdditionalCancel(payload){
      this.$emit('handleAdditionalCancel', payload);
    }
  },
  mounted(){
    this.$on('requestScrollBotom', () => {
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-message-app-message-view{
  box-sizing: border-box;
  width: calc(100vw - 3px); // スクロールバーが出てる際にmargin-rightがなくなるため
  height:100%;
  display: flex;
  overflow-x:hidden;
  overflow-y:scroll;
  // 本当はcolumn-reverseしたいのですが、mobile-safariでバグるのでいったん無し
  // flex-direction: column-reverse;

  &::-webkit-scrollbar {
    width: 5px;

    @media screen and (min-width: $desktop) {
      width:10px
    }
  }

  &::-webkit-scrollbar-thumb {
    background: #731F41;
    border-radius: 20px;
  }

  &::-webkit-scrollbar-track {
    background: #8E405F;
    border-radius: 20px;
    margin:8px 0;

    @media screen and (min-width: $desktop) {
      margin:8px 0;
    }
  }

  // https://github.com/lukejacksonn/react-slack-clone/blob/master/src/components/MessageList/index.module.css
  flex: 1 1 100%;
  margin: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  .message-list{
    width: 100%;
    margin-top: auto;
    display: flex;
    flex-direction: column;
    padding-top:1rem;

    .pa-message-set{
      margin-bottom:1rem;
    }

    @media screen and (min-width: $desktop) {
      padding-top:2rem;

      .pa-message-set{
        margin-bottom:1.5rem;
      }
    }
  }

  @media screen and (min-width: $desktop) {
    width:780px;
    margin:0 auto;
  }
}
</style>